var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobConwayPilot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 320 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #7997bc;\n      }\n\n      .cls-3 {\n        fill: #50eadb;\n      }\n\n      .cls-4 {\n        fill: #e3c5a9;\n      }\n\n      .cls-5 {\n        fill: #6d6e70;\n      }\n\n      .cls-6 {\n        fill: #724526;\n      }\n\n      .cls-7 {\n        fill: #5e3418;\n      }\n\n      .cls-8 {\n        fill: #eaceb9;\n      }\n\n      .cls-9 {\n        fill: #2b2b89;\n      }\n\n      .cls-10 {\n        fill: #261b1f;\n        opacity: .6;\n      }\n\n      .cls-11 {\n        fill: #3939b2;\n      }\n\n      .cls-12 {\n        fill: #7c4b27;\n      }\n\n      .cls-13 {\n        fill: #9f6b46;\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-15 {\n        fill: #d8b89a;\n      }\n\n      .cls-16 {\n        fill: #86562e;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 320,
    height: 432
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "293.86 442.42 22.41 442.42 79.4 388.49 105.44 341.42 211.03 341.42 237.26 389.37 293.86 442.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "187.41 442.42 129.41 442.42 103.41 374.77 101.41 307.42 214.41 307.42 213.41 374.77 187.41 442.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "187.11 442.42 128.71 442.42 103.41 325.42 213.41 325.42 187.11 442.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "180.82 402.78 157.84 432.25 134.85 402.78 126.13 355.42 157.84 365.42 189.55 355.42 180.82 402.78"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "196 241.42 288.67 143.29 281.84 132.43 173.58 222.68 196 241.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "193.26 232.42 218.48 164.11 212.45 159.82 180 222.42 193.26 232.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "218.24 163.8 194.73 111.49 197.23 130.43 210.46 165.63 218.24 163.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "289 143.27 288.95 35.93 295.89 22.08 281.52 33.86 270.77 143.77 289 143.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "288.82 59.35 264.27 18.71 253.14 4.64 249.71 5.65 262.62 25 281.62 62.82 288.82 59.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "288.5 127.26 318.05 76.17 318.18 66.99 278.8 118.73 288.5 127.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "234.22 186.92 249.02 146.85 245.48 144.33 226.44 181.05 234.22 186.92"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "222.64 260.69 189.46 236.6 221.18 209.14 284.35 193.23 258.07 249.44 222.64 260.69"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "121.41 241.42 28.74 143.29 35.57 132.43 143.83 222.68 121.41 241.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "124.15 232.42 98.93 164.11 104.96 159.82 137.41 222.42 124.15 232.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "99.16 163.8 122.67 111.49 120.17 130.43 106.95 165.63 99.16 163.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "28.41 143.27 28.46 35.93 21.51 22.08 35.89 33.86 46.64 143.77 28.41 143.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "28.59 59.35 53.13 18.71 64.27 4.64 67.7 5.65 54.78 25 35.79 62.82 28.59 59.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "28.9 127.26 -.64 76.17 -.77 66.99 38.61 118.73 28.9 127.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "83.19 186.92 68.39 146.85 71.93 144.33 90.96 181.05 83.19 186.92"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "95.29 260.69 128.46 236.61 96.75 209.15 33.57 193.24 59.86 249.45 95.29 260.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "179.41 379.42 158.41 387.42 137.41 379.42 102.5 331.42 94.41 260.42 143.63 222.84 158.41 224.42 173.5 222.98 222.41 260.42 214.32 331.42 179.41 379.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "173.28 370.82 158.46 375.42 143.63 370.82 139.59 361.64 158.46 360.19 177.32 361.64 173.28 370.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "180.46 365.42 158.46 365.42 136.46 365.42 130.46 341.42 149.44 313.35 158.46 314.42 167.08 313.27 186.46 341.42 180.46 365.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "169.38 355.84 158.46 357.42 147.54 355.84 143.96 341.83 158.46 339.42 172.95 341.83 169.38 355.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "233.34 255.97 205.37 233.65 232.27 214.23 280.52 200.58 257.28 248.73 233.34 255.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "144.97 367.45 158.36 369.73 171.76 367.45 175.41 365.69 158.36 365.42 141.31 365.69 144.97 367.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "136.25 301.6 118.41 305.01 111.39 297.44 110.47 290.35 121.6 288.38 127.55 291.4 136.25 301.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "177.2 263.8 158.58 269.42 139.96 263.8 126.41 235.42 143.93 221.91 158.58 224.53 173.24 221.91 190.41 235.42 177.2 263.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "84.33 255.74 112.3 233.43 85.4 214.01 37.15 200.36 60.4 248.51 84.33 255.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "229.99 377.11 280.99 407.11 279.99 383.11 219.99 358.11 229.99 377.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "180.94 301.73 198.77 305.14 205.8 297.57 206.72 290.48 195.59 288.51 189.64 291.53 180.94 301.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "86.41 378.42 35.41 408.42 36.41 384.42 96.41 359.42 86.41 378.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "320.16 459.42 -2.41 459.42 12.48 401.42 37.38 383.42 158.88 423.28 280.38 383.42 305.27 401.42 320.16 459.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "259.16 459.42 56.59 459.42 71.48 391.42 136.38 401.42 157.88 409.28 179.38 401.42 244.27 391.42 259.16 459.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "86.41 459.42 48.41 459.42 40.93 404.71 45.41 386.96 90.41 370.01 103.75 395.81 95.63 444.71 86.41 459.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "230.41 459.42 265.41 459.42 274.11 404.71 270.41 386.96 226.41 370.01 213.12 396.03 221.16 444.7 230.41 459.42"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobConwayPilot);
export default __webpack_public_path__ + "static/media/mob-conway-pilot.cb96370b60248d0c8ed5a82e6f51a2c5.svg";
export { ForwardRef as ReactComponent };